import React from 'react';

const Copyright = () => <div style={{ textAlign: 'right', color: '#aaa', marginTop: 5, marginBottom: 30 }}>© Artprice.com</div>;

export default Copyright;
